import _ from 'lodash';

export const toQueryProperties = (properties) => {
  return _.uniq(
    properties.map((p) => p.folderProperty?.query || p.query)
  ).filter((x) => x != null);
};
